module.exports = __webpack_public_path__ + "static/media/arrow_long_left_dark.4ba5ba2b.svg";